import { HCP_ROLES, RoleType } from '@csp/dmdp-api-common-dto';

export const HCPRoles = HCP_ROLES;
export const CRARole = RoleType.CRA;
export const supportUserRoles: RoleType[] = [RoleType.GSTM, RoleType.SSTM];
